import { combineReducers } from 'redux';
import _ from 'lodash';
import { REQUEST_APPLY_COUPON, RECEIVE_APPLY_COUPON, REMOVE_COUPON } from './actions';
import config from '../../config/config';

const isFetching = (state = false, action) => {
  switch (action.type) {
    case REQUEST_APPLY_COUPON:
      return true;
    case RECEIVE_APPLY_COUPON:
      return false;
    default:
      return state;
  }
};

const coupon = (state = '', action) => {
  switch (action.type) {
    case REQUEST_APPLY_COUPON:
      return state;
    case RECEIVE_APPLY_COUPON:
      return action.couponCode;
    case REMOVE_COUPON:
      return '';
    default:
      return state;
  }
};

const sumDiscount = (state = 0, action) => {
  switch (action.type) {
    case REQUEST_APPLY_COUPON:
      return state;
    case RECEIVE_APPLY_COUPON:
      return action.couponData?.data?.discount || 0;
    case REMOVE_COUPON:
      return 0;
    default:
      return state;
  }
};

export const getDiscount = state => state.coupon;
export const getDiscountFetching = state => state.isFetching;
export const getSumDiscount = state => state.sumDiscount;

const discount = combineReducers({
  isFetching,
  coupon,
  sumDiscount,
});

export default discount;